
import Accordion from '@/components/zs-components/Accordion.vue';
import ZSButton from '@/components/zs-components/ZSButton.vue';
import ZSChip from '@/components/zs-components/ZSChip.vue';
import ZSDropdown from '@/components/zs-components/ZSDropdown.vue';
import ZSIconShow from '@/components/zs-components/ZSIconShow.vue';
import ZSTab from '@/components/zs-components/ZSTab.vue';
import ZSTabView from '@/components/zs-components/ZSTabView.vue';
import ZSTooltip from '@/components/zs-components/ZSTooltip.vue';
import ZSDashGrid from '@/components/zs-components/ZSDashGrid.vue';
import ZSDashGridItem from '@/components/zs-components/ZSDashGridItem.vue';
import Loader from '@/components/zs-components/data/Loader.vue';
import ZSGrid from '@/components/zs-components/data/ZSGrid.vue';
import ZSList from '@/components/zs-components/data/ZSList.vue';
import ZSPaginator from '@/components/zs-components/data/ZSPaginator.vue';
import ZSTree from '@/components/zs-components/data/ZSTree.vue';
import ZSGridFilter from '@/components/zs-components/data/filter/ZSGridFilter.vue';
import ZSCheckBox from '@/components/zs-components/form/ZSCheckBox.vue';
import ZSCheckboxGroup from '@/components/zs-components/form/ZSCheckboxGroup.vue';
import ZSChipInput from '@/components/zs-components/form/ZSChipInput.vue';
import ZSDatePicker from '@/components/zs-components/form/ZSDatePicker.vue';
import ZSInput from '@/components/zs-components/form/ZSInput.vue';
import ZSMultiSelect from '@/components/zs-components/form/ZSMultiSelect.vue';
import ZSRadioButton from '@/components/zs-components/form/ZSRadioButton.vue';
import ZSSelect from '@/components/zs-components/form/ZSSelect.vue';
import ZSSwitch from '@/components/zs-components/form/ZSSwitch.vue';
import ZSTextArea from '@/components/zs-components/form/ZSTextArea.vue';
import ZSIcon from '@/components/zs-components/global/ZSIcon.vue';
import ZSMainArea from '@/components/zs-components/layout/ZSMainArea.vue';
import ZSPage from '@/components/zs-components/layout/ZSPage.vue';
import ZSNav from '@/components/zs-components/navigation/ZSNav.vue';
import ZSDialog from '@/components/zs-components/overlay/ZSDialog.vue';
import ZSDrawer from '@/components/zs-components/overlay/ZSDrawer.vue';
import ZSToast from '@/components/zs-components/toast/ZSToast.vue';
import ZSToastContainer from '@/components/zs-components/toast/ZSToastContainer.vue';
import ZSSCrolltop from '@/components/zs-components/ZSSCrolltop.vue';
import ZSForm from '../components/zs-components/form/ZSForm.vue';
import ZSBreakpointViewer from '../components/zs-components/ZSBreakpointViewer.vue';

const components = {
    Accordion,
    ZSButton,
    ZSChip,
    ZSDropdown,
    ZSIconShow,
    ZSTab,
    ZSTabView,
    ZSTooltip,
    ZSDashGrid,
    ZSDashGridItem,
    Loader,
    ZSGrid,
    ZSList,
    ZSPaginator,
    ZSTree,
    ZSGridFilter,
    ZSCheckBox,
    ZSCheckboxGroup,
    ZSChipInput,
    ZSDatePicker,
    ZSInput,
    ZSMultiSelect,
    ZSRadioButton,
    ZSSelect,
    ZSSwitch,
    ZSTextArea,
    ZSIcon,
    ZSMainArea,
    ZSPage,
    ZSNav,
    ZSDialog,
    ZSDrawer,
    ZSToast,
    ZSToastContainer,
    ZSSCrolltop,
    ZSForm,
    BV:ZSBreakpointViewer
};

export default {
    install(app) {
        for (const key in components) {
            app.component(key, components[key]);
        }
    }
};
